import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container, makeStyles } from '@material-ui/core';
import { useFspConfigPalValidation, useAuth } from 'hooks';
import { isPalGuestPaymentGroup } from 'util/rbac';
import { selectedFspIdSelector } from 'selectors/fsp';
import { selector as requestSelector } from 'selectors/request';
import { LOAD } from 'model/fspConfigPayALoan';
import { SEARCH_PATH } from '../paths';
import ConfirmDialog from './ConfirmDialog';
import PalGuestPaymentForm from './PalGuestPaymentForm';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const PalGuestPayment = () => {
  const classes = useStyles();
  const history = useHistory();
  const fspId = useSelector(selectedFspIdSelector);
  const [loanResult, setLoanResult] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { isValid } = useFspConfigPalValidation();
  const auth = useAuth();
  const hasGroupAccess =
    auth?.groups?.some((g) => isPalGuestPaymentGroup(g.name)) ?? false;
  const [requestCompleted, requestFailed] = useSelector((state) =>
    requestSelector(state, LOAD)
  );
  const isRequestDone = requestCompleted || requestFailed;
  const handleSuccess = useCallback((result) => {
    setLoanResult(result);
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  useEffect(() => {
    if (!fspId || !hasGroupAccess) {
      history.replace(SEARCH_PATH);
      return;
    }

    if (isRequestDone && !isValid) {
      history.replace(SEARCH_PATH);
    }
  }, [fspId, hasGroupAccess, history, isRequestDone, isValid]);

  if (!fspId || !hasGroupAccess || (isRequestDone && !isValid)) {
    return null;
  }

  return (
    <Container className={classes.container}>
      <PalGuestPaymentForm onSuccess={handleSuccess} />
      <ConfirmDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        loanResult={loanResult}
      />
    </Container>
  );
};

export default PalGuestPayment;
